import styled, { css } from 'styled-components'
import { ColorsEnum } from 'types/cssTypes'

interface IProps {
  text: string
  bgColor?: keyof typeof ColorsEnum
  className?: string
}

export const Label = ({ text, className, bgColor = ColorsEnum.primary }: IProps) => {
  return (
    <Span bgColor={bgColor} className={className}>
      {text?.replace(/_+/g, ' ')}
    </Span>
  )
}

const Span = styled.span<{ bgColor: keyof typeof ColorsEnum }>`
  display: inline-block;
  ${({ bgColor, className }) => {
    if (!className) {
      return css`
        color: ${({ theme }) => theme.colors.grey.lightest};
        background: ${({ theme }) => theme.colors[bgColor].neutral};
        padding: 0.25em 0.875em;
        border-radius: 5px;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
      `
    }
  }}

  &:first-letter {
    text-transform: capitalize;
  }
`
